import { CLICK_ID_LABELS } from 'dashboard/constants/brandConstants';

export { CLICK_ID_LABELS };

export const ALL_CLICK_ID_KEYS = Object.keys(CLICK_ID_LABELS);

export const MESES = [
  'Jan',
  'Fev',
  'Mar',
  'Abr',
  'Mai',
  'Jun',
  'Jul',
  'Ago',
  'Set',
  'Out',
  'Nov',
  'Dez',
];

export function formatTsLabel(timestamp, groupBy = 'day') {
  const d = new Date(timestamp);
  if (groupBy === 'month') return MESES[d.getMonth()];
  if (groupBy === 'week') return `${d.getDate()} ${MESES[d.getMonth()]}`;
  return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}`;
}

export function fmtCurrency(v) {
  return `R$ ${Number(v || 0).toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

export function fmtNum(v) {
  return Number(v || 0).toLocaleString('pt-BR');
}

export function sourceIcon(source) {
  const s = (source || '').toLowerCase();
  if (s.includes('google')) return 'i-lucide-search';
  if (s.includes('facebook') || s.includes('meta') || s.includes('instagram'))
    return 'i-lucide-facebook';
  if (s.includes('tiktok')) return 'i-lucide-music';
  if (s.includes('linkedin')) return 'i-lucide-linkedin';
  if (s.includes('twitter') || s.includes('x')) return 'i-lucide-twitter';
  if (s.includes('email') || s.includes('newsletter')) return 'i-lucide-mail';
  if (s.includes('organic') || s.includes('seo')) return 'i-lucide-leaf';
  return 'i-lucide-globe';
}

export function platformIcon(platform) {
  const p = (platform || '').toLowerCase();
  if (p === 'instagram') return 'i-lucide-instagram';
  if (p === 'facebook') return 'i-lucide-facebook';
  if (p === 'messenger') return 'i-lucide-message-circle';
  if (p === 'whatsapp') return 'i-lucide-message-square';
  if (p === 'youtube') return 'i-lucide-youtube';
  if (p.includes('google')) return 'i-lucide-search';
  if (p === 'tiktok') return 'i-lucide-music';
  if (p === 'linkedin') return 'i-lucide-linkedin';
  if (p === 'twitter') return 'i-lucide-twitter';
  if (p === 'pinterest') return 'i-lucide-image';
  if (p === 'snapchat') return 'i-lucide-ghost';
  if (p === 'reddit') return 'i-lucide-hash';
  return 'i-lucide-smartphone';
}

export function parseUserAgent(ua) {
  if (!ua) return null;
  const parts = [];
  if (ua.includes('Chrome') && !ua.includes('Edg')) parts.push('Chrome');
  else if (ua.includes('Edg')) parts.push('Edge');
  else if (ua.includes('Firefox')) parts.push('Firefox');
  else if (ua.includes('Safari') && !ua.includes('Chrome'))
    parts.push('Safari');
  else parts.push('Outro');
  if (ua.includes('Windows')) parts.push('Windows');
  else if (ua.includes('Mac OS')) parts.push('macOS');
  else if (ua.includes('Android')) parts.push('Android');
  else if (ua.includes('iPhone') || ua.includes('iPad')) parts.push('iOS');
  else if (ua.includes('Linux')) parts.push('Linux');
  if (ua.includes('Mobile')) parts.push('Mobile');
  return parts.join(' \u00B7 ');
}

export function formatAttrDate(timestamp) {
  if (!timestamp) return null;
  try {
    return new Date(timestamp).toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return timestamp;
  }
}

export function truncateStr(str, len) {
  if (!str || str.length <= len) return str;
  return str.slice(0, len) + '...';
}

export function buildTouchFields(attribution) {
  if (!attribution) return [];
  const formatSource = attr => {
    const parts = [];
    if (attr.utm_source) parts.push(attr.utm_source);
    if (attr.utm_medium) parts.push(attr.utm_medium);
    return parts.join(' / ') || null;
  };

  return [
    {
      label: 'Origem / Midia',
      value: formatSource(attribution),
      icon: sourceIcon(attribution.utm_source),
    },
    {
      label: 'Campanha',
      value: attribution.utm_campaign || null,
      icon: 'i-lucide-megaphone',
    },
    {
      label: 'Termo',
      value: attribution.utm_term || null,
      icon: 'i-lucide-text-search',
    },
    {
      label: 'Conteudo',
      value: attribution.utm_content || null,
      icon: 'i-lucide-file-text',
    },
    {
      label: 'Landing Page',
      value: attribution.landing_page || attribution.landing_page_url || null,
      icon: 'i-lucide-link',
      truncateValue: true,
    },
    {
      label: 'Referrer',
      value: attribution.referrer_url || null,
      icon: 'i-lucide-external-link',
      truncateValue: true,
    },
    {
      label: 'IP',
      value: attribution.ip_address || null,
      icon: 'i-lucide-wifi',
    },
    {
      label: 'Navegador / SO',
      value: attribution.user_agent
        ? parseUserAgent(attribution.user_agent)
        : null,
      icon: 'i-lucide-monitor',
    },
    {
      label: 'Canal',
      value: attribution.channel || null,
      icon: 'i-lucide-radio',
    },
    {
      label: 'Plataforma',
      value: attribution.platform || null,
      icon: platformIcon(attribution.platform),
    },
    {
      label: 'Data',
      value: formatAttrDate(attribution.created_at || attribution.timestamp),
      icon: 'i-lucide-clock',
    },
  ];
}
